import { FormProvider } from 'react-hook-form';
import { useCreateClientContractTermForm } from './hooks';
import { convertToPresentationProps } from './logics';
import { CreateClientContractTermFormPresentation } from './presentations';

/**
 * 企業契約期間 新規作成 Container
 *
 * - FormProvider でフォームコンテキストを提供し、Presentation 内の Controller が参照する
 * - サーバー側は終了日に月末日以外を受け付けないため、convertToPresentationProps で
 *   終了日カレンダーの選択制限（月末日のみ選択可）を導出する（PEN-1158）。
 */
export const CreateClientContractTermForm: React.FC = () => {
  const {
    state: { methods, isMutating, handleSearchClients, handleSearchContractPlans },
    actions: { handleSubmit, handleCancel },
  } = useCreateClientContractTermForm();

  const { endedOnDisabledDate } = convertToPresentationProps();

  return (
    <FormProvider {...methods}>
      <CreateClientContractTermFormPresentation
        searchAction={handleSearchClients}
        contractPlanSearchAction={handleSearchContractPlans}
        endedOnDisabledDate={endedOnDisabledDate}
        isButtonDisabled={isMutating}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
